import { Injectable } from "@angular/core";

import { Extension } from "@codemirror/state";
import { EditorView, tooltips } from "@codemirror/view";


@Injectable()
export class CodeEditorTooltipService {

    public getTooltipStyleExtension(): Extension {
        return EditorView.theme({
            ".cm-tooltip": {
                color: "black",
                backgroundColor: "white",
            },
            ".cm-tooltip.cm-tooltip-autocomplete": {
                color: "black",
                backgroundColor: "white",
            },
            ".cm-tooltip.cm-tooltip-autocomplete [aria-selected='true']": {
                color: "white",
                backgroundColor: "#0088ff !important",
            }
        });
    }

    public getTooltipPositionExtension(): Extension {
        return tooltips({
            tooltipSpace: (view: EditorView): DOMRect => {
                const rect: DOMRect = view.dom.getBoundingClientRect();
                return new DOMRect(rect.left, rect.top, rect.width, rect.height);
            }
        })
    }
}